/* eslint-disable */
import React, { useState, useReducer,useEffect} from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import { Button, Row, Col, Input, Drawer, Radio, Typography, Popover, message, Switch, Modal, Table, Spin, Tooltip,Collapse } from "antd";
import { InfoCircleOutlined, CheckCircleFilled, CloseOutlined,  DownOutlined} from "@ant-design/icons";
import { updateStudy,getStudy, createScenario, saveTemplateScenario, getProtocolComplexity, getChartsData } from "../../utils/ajax-proxy";
import ReactECharts from 'echarts-for-react';
import iconProtocolDesign from "../../assets/new-icon-protocol-design.png";
import iconDigitalProtocol from "../../assets/new-icon-digital-protocol.png";
import iconSiteSelection from "../../assets/new-icon-country-site-selection.png";
import iconTrialBudgeting from "../../assets/new-icon-trial-budgeting.png";
import history_icon from "../../assets/history_icon.svg"; 
import { MoreOutlined } from '@ant-design/icons';
import { getEmail, getAdminRole } from "../../utils/auth";
import { roundToWholeNumber, convertToHours, displayTimeInHoursOrMins } from '../../utils/utils';
import { formatWithCommas,toSentenceCase } from "../../utils/utils";
import "./index.scss";
import moment from 'moment-timezone';
import { USE_CASS_MODULE, DIGITIZED_PROTOCOL_MODULE } from '../../constants'
import { defaultChartData } from '../../pages/ChartSummary'
import { formatCostAvg } from "../../utils/utils";
import ExploreModule from "./components/ExploreModule";
import { TrialDetails,IEDetails,EndpointDetails,SOADetails, Section } from "./types";
const { TextArea } = Input;
const { Text } = Typography;

const { Panel } = Collapse;



interface ComplexityDetails {
  trial?: TrialDetails;
  endpoint?: EndpointDetails;
  ie?: IEDetails;
  soa?: SOADetails;
}

const initialStates = {
  ts_id: "",
  scenario_name: "",
  scenario_description: "",
  "Inclusion Criteria": {},
  "Exclusion Criteria": {},
  "Enrollment Feasibility": {},
  "Schedule of Events": {},
  "is_template": false
};

const initialCloneStates = {
  ts_id: "",
  scenario_name: "",
  scenario_description: "",
};

const SceneriosDashbaord = (props: any) => {
  const { record, afterSave } = props; 
  const isAdmin = localStorage.getItem('user_type').toUpperCase() == 'ADMIN';

  const [newScenarioVisiable, setNewScenarioVisiable] = useState(false);
  const [completeModuleVisible, setCompleteModuleVisible] = useState(false);
  const [scenarioType, setScenarioType] = useState();
  const [scenarioId, setScenarioId] = useState('');
  const [editFlag, setEditFlag] = useState(false);
  const [protocolAmendmentAvg, setProtocolAmendmentAvg] = useState('');
  const [screenFailureAvg, setScreenFailureAvg] = useState('');
  const [CostAvg, setCostAvg] = useState('');
  const [BurdenAvg, setBurdenAvg] = useState('');
  const [CostAvgValue, setCostAvgValue] = useState('');
  const [scenario, setScenario] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { ...initialStates }
  );
  const [scenarioList, setScenarioList] = useState([])
  const [scenarioNameError, setScenarioNameError] = useState("");
  const [scenarioDesError, setScenarioDesError] = useState("");
  const [rationaleMsgError, setRationaleMsgError] = useState("Rationale must not exceed 500 characters");
  const [cloneScenarioObj, setCloneScenarioObj] =  useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { ...initialCloneStates }
    );
    const [cloneScenario, setCloneScenario] = useState(false)
    const [cloneScenarioDisplayMessages, setCloneScenarioDisplayMessages] = useState({title: 'Copy and Create New Scenario', message: 'Scenario Names must be unique. Please modify before creating a new scenario'})
    const [readOnlyUser, setReadOnlyUser] = useState(false);
    const [fromTemplate, setFromTemplate] = useState(false);
    const [isCreateDrawer, setIsCreateDrawer] = useState(false);
    const [visible, setVisible] = useState(false)
    const [popoverStates, setPopoverStates] = useState([]);
    const [duplicateScenarioError, setDuplicateScenarioError] = useState('')
    const [isOncology, setOncologyFlay] = useState(false)
    const [disableCreateBtn, setDisableCreateBtn] = useState(false)
    const [isFinalisedScenario, setIsFinalisedScenario] = useState(false)
    const [activeKey, setActiveKey] = useState(['0','1','2','3'])



  const PopoverClick = (e, s, clone) => {
    e.stopPropagation();
    if(!clone || readOnlyUser) return;
    editScenario(s);
    setCloneScenario(true)
    setIsCreateDrawer(false)
    // const newScenarioId = (props.record.scenarios.length + 1);
    setCloneScenarioObj({
      ['ts_id']: s['ts_id'],
      ['scenario_name']: s['scenario_name'],
      ['scenario_description']: s['scenario_description'],
      scenario_type: s['scenario_type'],
    });
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onSaveTemplateScenario = async(e, s, idx) => {
    e.stopPropagation();
    let requestData = {
      "trial_uuid": record['trial_uuid'],
      "scenario": s,
      "user_name":  getEmail()
    }
    handlePopoverVisibleChange(idx, false)
    const resp = await saveTemplateScenario(requestData);
    if (resp.state ==  "Success") {
      afterSave(record['trial_uuid'])
    }
  }

  useEffect(() => {
    return () => {
      message.destroy();
    };
  }, []);

  const handleVisibleChange = (val) => {
    setVisible( val )
  }

  const getScenarioInfo = (record) => { 
    if(record?.template_details?.length == 0) return;
    const { template_details: { created_by, scenario_name, trial_alias, updated_by, updated_on } } = record;
     
    const content = (
      <div>
        <p> <span style={{display: 'inline-block', width: '150px'}}>Trial Alias: </span>{trial_alias}</p>
        <p> <span style={{display: 'inline-block', width: '150px'}}>Scenario Name: </span>{scenario_name}</p>
        <p> <span style={{display: 'inline-block', width: '150px'}}>Scenario Created By: </span>{created_by}</p>
        <p> <span style={{display: 'inline-block', width: '150px'}}>Last Updated By: </span>{updated_by} </p>
        <p> <span style={{display: 'inline-block', width: '150px'}}>Last Updated On: </span>{moment(new Date(updated_on)).format('YYYY-MM-DD')}</p> 
      </div>
    )
    return content
  }
  const handlePopoverVisibleChange = (index, visible) => { 
    const newStates = [...popoverStates];
    newStates[index] = visible;
    setPopoverStates(newStates);
  };

  const getContent = (s, idx) => {
    const  content = (
      <div>
        {
          isAdmin && !s.is_template && <div style={{cursor:readOnlyUser ? 'auto' : "pointer",'paddingBottom': '6%'}} onClick={(e) => onSaveTemplateScenario(e, s, idx)}>Save as Template Scenario</div>
        }
        <div
        style={{cursor:`${props.record.status.toLowerCase() === 'updating'?"not-allowed":(readOnlyUser ? 'not-allowed' : "pointer")}`}}
        onClick={(e) => {
          if(props.record.status.toLowerCase() === 'updating')return
          PopoverClick(e, s, true);
          handlePopoverVisibleChange(idx, false)
          }}>
          Copy and create new scenario
        </div>
      </div>
    );
    return content
  }

  useEffect(() => {
    setOncologyFlay(record?.oncology_flag)
  }, [record])

  useEffect(() => {
    const scenario_list = JSON.parse(JSON.stringify(props.record.scenarios))
    setScenarioList(scenario_list)
    if(props.record.therapeutic_area_average != undefined){
      let protocol_amendment_avg = props.record.therapeutic_area_average.protocol_amendment_rate ?? '';
      let screen_failure_avg = props.record.therapeutic_area_average.screen_failure_rate === null? 'N/A': props.record.therapeutic_area_average.screen_failure_rate?? '';
      let cost_avg = props.record.therapeutic_area_average.cost_avg != undefined?
                                props.record.therapeutic_area_average.cost_avg : '';
      let burden_avg = props.record.therapeutic_area_average.burden_avg != undefined?
                                roundToWholeNumber(Number(props.record.therapeutic_area_average.burden_avg.toString().match(/^\d+(?:\.\d{0,2})?/)))+'' : '';
      setProtocolAmendmentAvg(protocol_amendment_avg)
      setScreenFailureAvg(screen_failure_avg)
      setCostAvg(cost_avg)
      setBurdenAvg(burden_avg)
      setCostAvgValue(formatCostAvg(cost_avg,1000))
    }
    if(props.record && props.record.trial_user_role && props.record.trial_user_role.toLowerCase() == 'read') {
      setReadOnlyUser(true)
     }else{
      setReadOnlyUser(false)
     }
     if(scenario_list?.length > 0) {
      const isFinalisedScenario = scenario_list.some(scenario => scenario["finalized"]);  
      setIsFinalisedScenario(isFinalisedScenario);  
     } else if (props?.location?.state?.scenarios?.length > 0) {
      const isFinalisedScenario = props?.location?.state?.scenarios?.some(scenario => scenario["finalized"]);  
      setIsFinalisedScenario(isFinalisedScenario);  
      setOncologyFlay(props?.location?.state?.oncology_flag)
     }
  }, [props.record.scenarios])
  const editScenario = (s) =>{
    setScenarioId(s['ts_id'])
    setScenario(s);
    setScenarioType(toSentenceCase(s['scenario_type']))
    setNewScenarioVisiable(true)
    setEditFlag(true)
  }

  const addNewSelection = () => {
    window.open('https://d16dvkwbjk4ihl.cloudfront.net/', '_blank');
  }

  const addNewScenario =(scenarioType) => {
    if( props.record && props.record.trial_user_role && props.record.trial_user_role.toLowerCase() == 'read') return;
    // const newScenarioId = '' + (props.record.scenarios.length + 1)
    // setScenarioId(newScenarioId)
    setScenario({
      // ['ts_id']: newScenarioId,
      ['scenario_type']:scenarioType
    });
    setScenarioType(toSentenceCase(scenarioType))
    setNewScenarioVisiable(true)
    setEditFlag(false)
    setIsCreateDrawer(true);
  }
 

  const getChartSummaryData = async (trial_uuid, ts_id) => {
    const response = await getChartsData(trial_uuid, ts_id + '');
    if(response?.length > 0) {
      localStorage.setItem('chartData', JSON.stringify(response));
    } else {
      localStorage.setItem('chartData', JSON.stringify(defaultChartData));
    }
  }

  const readOnlyUserHandler = () => {
    props.updateSoaActivities({
      currentVisitTypes: 'total_trial',
    })
    localStorage.setItem('ts_id', scenarioId)
    getChartSummaryData(props.record['trial_uuid'], scenarioId);
    props.history.push({
      pathname: '/scenario',
      state: {
        trial_id: props.record['trial_uuid'] ,
        scenarioId: scenarioId,
        editFlag: editFlag,
        scenarioType: scenarioType,
        similarHistoricalTrials: props.record['similarHistoricalTrials']
      }
    })
    setNewScenarioVisiable(false);
    setDuplicateScenarioError('');
    setCloneScenario(false)
  }


  const handleOk = async () => {
    props.updateSoaActivities({
      currentVisitTypes: 'total_trial',
    })
    let templateScenario, method;
    if(!doValidation() || !doDesValidation()) return
    setDisableCreateBtn(true)
    let currentScenario, newCloneScenario;
    if(editFlag && !cloneScenario){
      currentScenario =  scenario;
      method = "UpdateScenario"
    } else if(editFlag && cloneScenario) {
      currentScenario =  scenario
      newCloneScenario = cloneScenarioObj
      method = "CloneScenario"
    }else {
      method = "CreateScenario"
      currentScenario = {
          ts_id: scenario['ts_id'],
          scenario_name: scenario['scenario_name'],
          scenario_description: scenario['scenario_description'],
          scenario_type: scenario['scenario_type'],
          "Inclusion Criteria": {},
          "Exclusion Criteria": {},
          "Enrollment Feasibility": {},
          "Schedule of Events": {},
        }
    }
    // if(method === "UpdateScenario") {
    //   clearStorage(`endpoints_${scenario['ts_id']}`);
    //   clearStorage(`IncluEntityActivePanels_${scenario['ts_id']}`);
    //   clearStorage(`ExcluEntityActivePanels_${scenario['ts_id']}`);
    //   clearStorage(`expandKeys_${scenario['ts_id']}`);
    // }

      if(fromTemplate) {
        method = "CreateFromTemplate"
        templateScenario = record.scenarios.find(s=>s.is_template);
        currentScenario =  templateScenario ? JSON.parse(JSON.stringify(templateScenario)): {}
        currentScenario.is_template = false
        currentScenario["Inclusion Criteria"] = {}
        currentScenario["Exclusion Criteria"] = {}
        currentScenario["Enrollment Feasibility"] = {}
        currentScenario["Schedule of Events"] = {}
        currentScenario.ts_id = record.template_ts_id

        newCloneScenario = {
          // ['ts_id']: (props.record.scenarios.length + 1),
          ['scenario_name']: scenario['scenario_name'],
          ['scenario_description']: scenario['scenario_description'],
          scenario_type: scenario['scenario_type'],
        }
      }

      const tempTrial = props.record
      let requestData = {
      "trial_uuid": tempTrial['trial_uuid'],
      "scenario": currentScenario,
      "new_scenario": newCloneScenario,
      "user_name":  getEmail()
      }

      const resp = await createScenario(requestData, method);      
      if (resp.statusCode == 200) {
          localStorage.setItem('ts_id', resp.ts_id)
          setDisableCreateBtn(false)
          getChartSummaryData(props.record['trial_uuid'], resp.ts_id);
          props.history.push({
            pathname: '/scenario',
            state: {
              trial_id: props.record['trial_uuid'] ,
              scenarioId: resp.ts_id,
              editFlag: editFlag,
              scenarioType: scenarioType,
              similarHistoricalTrials: props.record['similarHistoricalTrials'],
              scenario_name: scenario['scenario_name']
            }
          })
          setNewScenarioVisiable(false);
          setDuplicateScenarioError('');
          setCloneScenario(false)
      } else if (resp.statusCode == 409) {
        localStorage.setItem('ts_id', null)
        setDisableCreateBtn(false)
        setDuplicateScenarioError('This scenario name already exists, please enter a unique name!');
        // message.error('Duplicate Record.');
      } else {
        localStorage.setItem('ts_id', null)
        setDuplicateScenarioError('');
        setDisableCreateBtn(false)
        // message.error('Failed with an API error.');
      }
  }


  const handleCancel = () =>{
      setNewScenarioVisiable(false)
      setScenario(initialStates)
      setScenarioNameError("")
      setDuplicateScenarioError('');
      setScenarioDesError("")
      setCloneScenario(false)
      setFromTemplate(false)
  }

  const handleInputChange = (key, e) => {
    if(cloneScenario) {
      setCloneScenarioObj({
        [key]: e.target.value,
      })
      } else {
    setScenario({
      [key]: e.target.value,
    });
    }

    if(key == "scenario_name" && e.target.value.trim().length > 100){
      setScenarioNameError("Scenario Name must not exceed 100 characters.")
    } else if (key == "scenario_name" && e.target.value.trim().length > 0 && e.target.value.trim().length < 101){
      setScenarioNameError("")
    }
  };

  const handleCheck = (e, idx) => {
    const tmpList = scenarioList.slice(0)
    if (e.target.checked) {
      tmpList.forEach(ele =>
        ele.finalized = false
      )
      tmpList[idx].finalized = true
    } else {
      tmpList[idx].finalized = false
    }
    setScenarioList(tmpList)
  }


  const onRationaleChange = (e, idx) => {
    const tmpList = scenarioList.slice(0)
    tmpList[idx].rationale = e.target.value
    setScenarioList(tmpList)

  }
  const showCompleteModule = (type) => {
    if( props.record && props.record.trial_user_role && props.record.trial_user_role.toLowerCase() == 'read') return;
    setCompleteModuleVisible(true)
    setScenarioType(type)
    props.history.push({
       pathname: '/compare-scenario',
       state: {
         trial_id: props.record['trial_uuid'] ,
         scenarios: scenarioList,
         record: props.record
       }
      })
  }

  const handleCompleteModule = async() => {
    if( props.record && props.record.trial_user_role && props.record.trial_user_role.toLowerCase() == 'read') return;
    let errorExists = false;
    scenarioList && scenarioList.length > 0 &&  scenarioList.filter(scenario => scenario["finalized"]).map((scenario, index) =>  errorExists = scenario["rationale"] && scenario.rationale.length > 500 ? true : false)
    if(errorExists) return
    const tempTrial =JSON.parse(JSON.stringify(props.record))
    tempTrial.scenarios = scenarioList
    tempTrial.status="Completed"
    const trialId=tempTrial["trial_uuid"]
    const resp = await updateStudy(tempTrial);
    if (resp) {
      props.updateRecord(tempTrial)
      const study = await getStudy(trialId, null, getEmail()) 
      if (study) {
        const newScenarios = study.scenarios
        setScenarioList(newScenarios)
        setCompleteModuleVisible(false)
      }
    } else{
      message.error("Failed to complete module");
    }
  }

  const cancelCompleteModule = () => {
    setCompleteModuleVisible(false)
    const tmpList = scenarioList.slice(0)
    if(tmpList) {
      tmpList.forEach(ele =>
        ele.finalized = false
      )
      setScenarioList(tmpList)
    }



  }

  const handleValidation = (key, v) => {
    let errorMsg = "";

    let scenarioObj = scenario;
    if(cloneScenario){
       scenarioObj = cloneScenarioObj;
    }
    if(scenarioObj["scenario_name"].trim().length < 1){
        errorMsg = "Scenario Name is required."
    } else if (scenarioObj["scenario_name"].trim().length > 100){
      errorMsg = "Scenario Name must not exceed 100 characters."
    }
    if(key == "scenarioName"){setScenarioNameError(errorMsg)}
    return errorMsg == ""
  }

  const handleDesValidation = (key, v) => {
    let errorMsg = "";

    let scenarioObj = scenario;
    if(cloneScenario){
       scenarioObj = cloneScenarioObj;
    }
    if (scenarioObj["scenario_description"].trim().length > 500){
      errorMsg = "Description must not exceed 500 characters."
  }
    if(key == "scenarioDescription"){setScenarioDesError(errorMsg)}
    return errorMsg == ""
  }

  const doValidation = () => {
    let reqFieldsEntered = true
    if(!handleValidation("scenarioName", null)){
      reqFieldsEntered = false
  }
    return reqFieldsEntered;
  }

  const doDesValidation = () => {
    let reqFieldsEntered = true
    if(!handleDesValidation("scenarioDescription", null)){
      reqFieldsEntered = false
  }
    return reqFieldsEntered;
  }
 function emptyMetricsValidation(scenarios)
  {
    for(let i=0;i<scenarios.length;i++)
    {
    if (scenarios[i]['protocol_amendment_rate'] === null)
    {
    scenarios[i]['protocol_amendment_rate'] = ''
    scenarios[i]['protocol_amendment_rate_state'] = ''
    }
    if (scenarios[i]['screen_failure_rate'] === null)
    {
    scenarios[i]['screen_failure_rate'] = ''
    scenarios[i]['screen_failure_rate_state'] = ''
    }
    if (scenarios[i]['dct_patient_burden'] === null){
    scenarios[i]['dct_patient_burden'] = ''
    scenarios[i]['dct_patient_burden_state'] = ''
    }
    if (scenarios[i]['cost'] === null){
    scenarios[i]['cost'] = ''
    scenarios[i]['cost_state']  = ''
    }
    }
  }
  
  if (props.record.scenarios && props.record.scenarios.length > 0){
      emptyMetricsValidation(props.record.scenarios)
  }

  const btnText = () => {
    let content;
    if(readOnlyUser) {
      content = "View scenario"
    } else   if(!isAdmin && scenario?.is_template && !cloneScenario){
      content = "View scenario"
    } else   if(isAdmin && scenario?.is_template && cloneScenario){
      content = "Create scenario"
    } else   if(isAdmin && scenario?.is_template && !cloneScenario){
      content = "Update scenario"
    } else   if(editFlag && !cloneScenario){
      content = "Update scenario"
    } else if(editFlag && cloneScenario) {
      content = "Create scenario"
    } else {
      content = "Create scenario"
    }
    return content;
  }
  const [openDialog, setOpenDialog] = useState(false)
  const [complexityDetails, setComplexityDetails] = useState<ComplexityDetails>({});
  const [mvpData, setMvpData] = useState<Section[]>([])
  const [loading, setLoading] = useState(true);

  const openProtocolComplexityDialog = async (e, s) => {
    e.stopPropagation();
    if (!s["scenario_complexity"] || s["scenario_complexity"] == '' || s["scenario_complexity"] == 'INCOMPLETE') return;
    let requestData = {
      "trial_uuid": record['trial_uuid'],
      "ts_id": s["ts_id"]
    }
    setOpenDialog(true) 
    // setComplexityDetails(requestData)
    const resp = await getProtocolComplexity(requestData); 
    if(resp) { 
      setComplexityDetails(resp) 
      setLoading(false)
    } 
  }
  const roundPercentile = (number) => {
    if(!number) return;
    if(typeof(number) == 'string' && number.toLowerCase() == "na") {
      let percentile = number; 
      return percentile
    }

    let percentage = Math.round(number * 100);
    if (percentage > 95) {
      return 95;
    } else if (percentage < 5) {
      return 5;
    } else {
      var roundedPercentage = Math.round(percentage / 5) * 5;
      return roundedPercentage;
    }
  }

  function customRound(input) {
      if (!input) {
        return input;
      } else {
        let number = Number(input);
        if (Number.isFinite(number)) {
          const roundedNumber = Math.round(number * 100) / 100;  
          const thirdDecimal = Math.floor(number * 1000) % 10;  
    
          if (thirdDecimal >= 5) {
            number = roundedNumber + 0.01;
            number = Number(number.toFixed(2));
          } else {
            number = roundedNumber;
          }
        }
        return formatWithCommas(Math.round(number));
      }
  }

  function printSuffix(number) {
    if(number === '' || number === 'NA' || number === null || number === '-') return;  
    const thirdDecimal = number % 10;

    let suffix = "th";
    if (thirdDecimal === 1) {
        suffix = "st";
    } else if (thirdDecimal === 2) {
        suffix = "nd";
    } else if (thirdDecimal === 3) {
        suffix = "rd";
    } else if (number === 0) {
      suffix = 'th';
    } else if (number === 'NA') {
      suffix = '';
    }
    return suffix
  }


  function checkComplexity(number) { 
    if(number === '' || number === 'NA' || number === null || number === '-') return;
    if (number >= 0 && number < 50) {
      return 'low-percentile';
    } else if (number >= 50 && number < 75) {
      return 'medium-percentile';
    } else if (number >= 75){
      return 'high-percentile';
    } else {
      return ''
    }
  }
 
  
  const columns: string[] = [
    "Protocol complexity metrics",
    "This trial",
    "Similar historical trials",
    "Percentile",
    ""
  ];
    useEffect(() => {
      const data = [
        {
          header: "Trial Design Complexity",
          status: toSentenceCase(complexityDetails["trial"]?.trial_complexity ?? ""),
          name: 'trial',
          rows: [
            {
              label: "Length of treatment in weeks",
              Trial: customRound(complexityDetails["trial"]?.treatment_duration_trial) ?? "-",
              Historic: customRound(complexityDetails["trial"]?.treatment_duration_hist) ?? "-",
              Percentile: complexityDetails["trial"]?.treatment_duration_percentile
                ? roundPercentile(complexityDetails["trial"]?.treatment_duration_percentile)
                : 5,
            },
            {
              label: "Number of arms",
              Trial: customRound(complexityDetails["trial"]?.number_of_arms_trial) ?? "-",
              Historic: customRound(complexityDetails["trial"]?.number_of_arms_hist) ?? "-",
              Percentile: complexityDetails["trial"]?.number_of_arms_percentile
                ? roundPercentile(complexityDetails["trial"]?.number_of_arms_percentile)
                : 5,
            },
          ],
        },
        {
          header: "Endpoint Complexity",
          status: toSentenceCase(complexityDetails["endpoint"]?.endpoint_complexity ?? ""),
          name: 'endpoint',
          rows: [
            {
              label: "Number of primary endpoints",
              Trial: customRound(complexityDetails["endpoint"]?.primary_endpoints_count_scenario) ?? "-",
              Historic: customRound(complexityDetails["endpoint"]?.primary_endpoints_count_hist) ?? "-",
              Percentile: complexityDetails["endpoint"]?.primary_endpoints_count_percentile
                ? roundPercentile(complexityDetails["endpoint"]?.primary_endpoints_count_percentile)
                : 5,
            },
            {
              label: "Number of secondary endpoints",
              Trial: customRound(complexityDetails["endpoint"]?.secondary_endpoints_count_scenario) ?? "-",
              Historic: customRound(complexityDetails["endpoint"]?.secondary_endpoints_count_hist) ?? "-",
              Percentile: complexityDetails["endpoint"]?.secondary_endpoints_count_percentile
                ? roundPercentile(complexityDetails["endpoint"]?.secondary_endpoints_count_percentile)
                : 5,
            },
            {
              label: "Unique primary endpoint entities",
              Trial: customRound(complexityDetails["endpoint"]?.unique_primary_endpoints_count_scenario) ?? "-",
              Historic: customRound(complexityDetails["endpoint"]?.unique_primary_endpoints_count_hist) ?? "-",
              Percentile: complexityDetails["endpoint"]?.unique_primary_endpoints_count_percentile
                ? roundPercentile(complexityDetails["endpoint"]?.unique_primary_endpoints_count_percentile)
                : 5,
            },
            {
              label: "Unique secondary endpoint entities",
              Trial: customRound(complexityDetails["endpoint"]?.unique_secondary_endpoints_count_scenario) ?? "-",
              Historic: customRound(complexityDetails["endpoint"]?.unique_secondary_endpoints_count_hist) ?? "-",
              Percentile: complexityDetails["endpoint"]?.unique_secondary_endpoints_count_percentile
                ? roundPercentile(complexityDetails["endpoint"]?.unique_secondary_endpoints_count_percentile)
                : 5,
            },
          ],
        },
        {
          header: "I/E Criteria Complexity",
          status: toSentenceCase(complexityDetails["ie"]?.ie_complexity ?? ""),
          name:'ie',
          rows: [
            {
              label: "Number of I/E entities",
              Trial: customRound(complexityDetails["ie"]?.entities_count_scenario) ?? "-",
              Historic: customRound(complexityDetails["ie"]?.entities_count_hist) ?? "-",
              Percentile: complexityDetails["ie"]?.entities_count_percentile
                ? roundPercentile(complexityDetails["ie"]?.entities_count_percentile)
                : 5,
            },
            {
              label: "I/E entities in past protocol amendments",
              Trial: customRound(complexityDetails["ie"]?.par_trial) ?? "-",
              Historic: customRound(complexityDetails["ie"]?.par_hist) ?? "-",
              Percentile: complexityDetails["ie"]?.par_percentile
                ? roundPercentile(complexityDetails["ie"]?.par_percentile)
                : 5,
            },
          ],
        },
        {
          header: "SoA Complexity",
          status: toSentenceCase(complexityDetails["soa"]?.soa_complexity ?? ""),
          name:'soa',
          rows: [
            {
              label: "Unique SoA activities",
              Trial: customRound(complexityDetails["soa"]?.soa_count_scenario) ?? "-",
              Historic: customRound(complexityDetails["soa"]?.soa_count_hist) ?? "-",
              Percentile: complexityDetails["soa"]?.soa_count_percentile
                ? roundPercentile(complexityDetails["soa"]?.soa_count_percentile)
                : 5,
            },
            {
              label: "Number of visits",
              Trial: customRound(complexityDetails["soa"]?.total_visits_scenario) ?? "-",
              Historic: customRound(complexityDetails["soa"]?.total_visits_hist) ?? "-",
              Percentile: complexityDetails["soa"]?.total_visits_percentile
                ? roundPercentile(complexityDetails["soa"]?.total_visits_percentile)
                : 5,
            },
            {
              label: "Patient burden",
              Trial: customRound(complexityDetails["soa"]?.pb_scenario) ?? "-",
              Historic: customRound(complexityDetails["soa"]?.pb_hist) ?? "-",
              Percentile: complexityDetails["soa"]?.pb_percentile
                ? roundPercentile(complexityDetails["soa"]?.pb_percentile)
                : 5,
            },
            {
              label: "Patient burden per visit",
              Trial: customRound(complexityDetails["soa"]?.pb_visit_scenario) ?? "-",
              Historic: customRound(complexityDetails["soa"]?.pb_visit_hist) ?? "-",
              Percentile: complexityDetails["soa"]?.pb_visit_percentile
                ? roundPercentile(complexityDetails["soa"]?.pb_visit_percentile)
                : 5,
            },
            {
              label: "Site burden",
              Trial: customRound(complexityDetails["soa"]?.sb_scenario) ?? "-",
              Historic: customRound(complexityDetails["soa"]?.sb_hist) ?? "-",
              Percentile: complexityDetails["soa"]?.sb_percentile
                ? roundPercentile(complexityDetails["soa"]?.sb_percentile)
                : 5,
            },
            {
              label: "Site burden per visit",
              Trial: customRound(complexityDetails["soa"]?.sb_visit_scenario) ?? "-",
              Historic: customRound(complexityDetails["soa"]?.sb_visit_hist) ?? "-",
              Percentile: complexityDetails["soa"]?.sb_visit_percentile
                ? roundPercentile(complexityDetails["soa"]?.sb_visit_percentile)
                : 5,
            },
            {
              label: "Patient time",
              Trial: complexityDetails["soa"]?.tb_scenario? displayTimeInHoursOrMins(complexityDetails["soa"]?.tb_scenario) : "-",
              Historic: complexityDetails["soa"]?.tb_hist ? displayTimeInHoursOrMins(complexityDetails["soa"]?.tb_hist) : "-",
              Percentile: complexityDetails["soa"]?.tb_percentile
                ? roundPercentile(complexityDetails["soa"]?.tb_percentile)
                : 5,
            },
            {
              label: "Patient time per visit",
              Trial: complexityDetails["soa"]?.tb_visit_scenario ? displayTimeInHoursOrMins(complexityDetails["soa"]?.tb_visit_scenario) : "-",
              Historic: complexityDetails["soa"]?.tb_visit_hist ? displayTimeInHoursOrMins(complexityDetails["soa"]?.tb_visit_hist) : "-",
              Percentile: complexityDetails["soa"]?.tb_visit_percentile
                ? roundPercentile(complexityDetails["soa"]?.tb_visit_percentile)
                : 5,
            },
          ],
        },
      ];
      setMvpData(data)
    }, [complexityDetails])
    
  
  const closeDialog = () => {
    setOpenDialog(false)
    setComplexityDetails({})
    setLoading(true)
  }

  const [disableDigitalProtocolModule, setDisableDigitalProtocolModule] = useState(true)
  
  useEffect(() => {
    if (isOncology) {  
      setDisableDigitalProtocolModule(true)
    } else if (isFinalisedScenario && !isOncology) {  
      setDisableDigitalProtocolModule(false);  
    } else {  
      setDisableDigitalProtocolModule(true);  
    }  
  }, [isOncology, isFinalisedScenario])

  const callback = (key) => {
    setActiveKey(key);
  }



  const complexityFields = [
    {
      label: "Length of treatment in weeks",
      path: ["trial", "treatment_duration"],
      formatter: customRound,
    },
    {
      label: "Number of arms",
      path: ["trial", "number_of_arms"],
      formatter: customRound,
    },
    {
      label: "Number of primary endpoints",
      path: ["endpoint", "primary_endpoints_count"],
      formatter: customRound,
    },
    {
      label: "Number of secondary endpoints",
      path: ["endpoint", "secondary_endpoints_count"],
      formatter: customRound,
    },
    {
      label: "Unique primary endpoint entities",
      path: ["endpoint", "unique_primary_endpoints_count"],
      formatter: customRound,
    },
    {
      label: "Unique secondary endpoint entities",
      path: ["endpoint", "unique_secondary_endpoints_count"],
      formatter: customRound,
    },
    {
      label: "Number of I/E entities",
      path: ["ie", "entities_count"],
      formatter: customRound,
    },
    {
      label: "I/E entities in past protocol amendments",
      path: ["ie", "par"],
      formatter: customRound,
    },
    {
      label: "Unique SoA activities",
      path: ["soa", "soa_count"],
      formatter: customRound,
    },
    {
      label: "Number of visits",
      path: ["soa", "total_visits"],
      formatter: customRound,
    },
    {
      label: "Patient burden",
      path: ["soa", "pb"],
      formatter: customRound,
    },
    {
      label: "Patient burden per visit",
      path: ["soa", "pb_visit"],
      formatter: customRound,
    },
    {
      label: "Site burden",
      path: ["soa", "sb"],
      formatter: customRound,
    },
    {
      label: "Site burden per visit",
      path: ["soa", "sb_visit"],
      formatter: customRound,
    },
    {
      label: "Patient time",
      path: ["soa", "tb"],
      formatter: convertToHours,
    },
    {
      label: "Patient time per visit",
      path: ["soa", "tb_visit"],
      formatter: convertToHours,
    },
  ];

  const histogramMapping = {};
  const scenarioValueMapping = {};

  complexityFields.forEach(({ label, path, formatter }) => {
    const [section, key] = path;
    histogramMapping[label] = complexityDetails?.[section]?.[`${key}_histogram`];
    const rawValue =
      complexityDetails?.[section]?.[`${key}_scenario`] ??
      complexityDetails?.[section]?.[`${key}_trial`];
    scenarioValueMapping[label] = formatter?.(rawValue);
  });

  function generateChartOptions(labelName) {
    const histogramData = histogramMapping[labelName];
    let scenarioValue = scenarioValueMapping[labelName];

    if (typeof scenarioValue === 'string') {
      scenarioValue = Number(scenarioValue.replace(/,/g, ''));
    }
    let xAxisData = [];
    let yAxisData = [];
    let diamondData = [];
    let titleText = '';

    if (histogramData === 'NA' || !Array.isArray(histogramData)) {
      xAxisData = [];
      yAxisData = [0];
    } else {
      const sortedData = [...histogramData].sort((a, b) => a.bucket - b.bucket);
      xAxisData = sortedData.map(item => item.bucket_width);
      yAxisData = sortedData.map(item => item.occurances);

      // Find the bucket that contains the scenario value
      if (scenarioValue !== undefined && scenarioValue !== null && scenarioValue !== 'NA' && scenarioValue !== 0) {
        const bucketIndex = sortedData.findIndex(item => {
          if (!item.bucket_width) return false;
          const [min, max] = item.bucket_width.split('-').map(Number);
          const minInHours = (labelName === "Patient time") ? convertToHours(min) : min;
          const maxInHours = (labelName === "Patient time") ? convertToHours(max) : max;
          return scenarioValue >= minInHours && scenarioValue <= maxInHours;
        });
        if (bucketIndex !== -1) {
          diamondData.push({
            value: [bucketIndex, yAxisData[bucketIndex] || 0],
            symbol: 'diamond',
            symbolSize: 10,
            itemStyle: {
              color: '#000000'
            },
          });
        } else{
            titleText = 'The scenario value is outside the range of peer dataset'
        }
      }
    }
    const maxOccurrence = Math.max(...yAxisData);
    const interval = Math.ceil(maxOccurrence / 5) || 1;
    const maxYValue = Math.ceil(maxOccurrence / interval) * interval || 5;
    return {
      title: {
        text: titleText,
        left: 'left',
        top: 'top',
        textStyle: {
          color: '#D04A02',
          fontSize: 12,
        },
      },
      grid: {  
        left: '12%',
        bottom:["Patient time", "Site burden", "Patient burden"].includes(labelName) ?'30%': '20%',
      },
      graphic: [
        {
          type: 'line',
           y: 40
        }
      ],
      xAxis: {
        type: 'category',
        data: xAxisData,
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          interval: 0,
          rotate: 45,
          formatter: (value, index) => {
            if(labelName === "Patient time") {
              // The patient time should be in hours
              const [min, max] = value!== null?value?.split('-')?.map(Number):[0,0];
              const pt_time = `${convertToHours(min)}-${convertToHours(max)}`;
              return index == 0 ? pt_time: `> ${pt_time}`
            } else {
              return index === 0 ? value : `> ${value}`;
            }
          },
        },
      },
      yAxis: {
        type: 'value',
        name: 'Number of historical trials',
        min: 0,
        max: maxYValue,
        interval,
        splitNumber: 5,
        nameLocation: 'middle',
        nameGap: 45,
        axisLabel: {
          show: true,
          formatter: (value) => `${value}`,  
        },
      },
      tooltip: {
        show: true,
        trigger: 'item',
        formatter: function (param) {
          if (param.seriesType === 'scatter') {
            return `Scenario value - ${scenarioValue}`;
          }
          return formatWithCommas(yAxisData[param.dataIndex]);
        },
      },
      series: [
        {
          type: 'bar',
          data: yAxisData.map((value, index) => ({
            value: [index, value],
            itemStyle: {
              color: '#D04A02',
            },
          })),
        },
        {
          type: 'scatter',
          data: diamondData,
        },
      ],
    };
  }
  
  return (
    <div className="scenarios-container">
      <div className="container-top">What would you like to explore today?</div>
      <div className="module-wrapper">
        <div className="module-item">
          <div className="top">
            <div className="icon-placeholder">
              <img src={iconProtocolDesign} alt="" width="28px" height="28px" />
            </div>
            <div className="module-name">
              Protocol design
              <span className="scenario-status">
                <i className={`${props.record.status!=="Completed"?"in-progress-icon":'complete-icon'} my_icon`}></i>
                {toSentenceCase(props.record.status)}
              </span>
            </div>
            {props.record.scenarios && props.record.scenarios.length > 0 ? (
              <div>
                <Button
                  className="complete-module-btn"
                  type="link"
                  onClick={() => showCompleteModule("Protocol design")}
                  disabled={props.record.status.toLowerCase() === 'updating' || readOnlyUser}
                >
                  Compare / Complete scenario
                </Button>
                <Button
                  className="new-scenario-btn"
                  danger
                  onClick={() => addNewScenario("Protocol Design")}
                  disabled={props.record.status.toLowerCase() === 'updating'|| readOnlyUser}
                >
                  Create scenario
                </Button>
              </div>
            ) : (
              <Button
                type="primary"
                onClick={() => addNewScenario("Protocol Design")}
                disabled={props.record.status?.toLowerCase() === 'updating'||localStorage.getItem('trial-id')===''}
              >
                Start module
              </Button>
            )}
          </div>
          {props.record.scenarios && props.record.scenarios.length > 0 ?
            (
              <div className="scenarios-list-container">
                <div className="scenarios-list">
                  <div className="scenario-item scenario-header">
                    <div className="title">
                      Scenarios (<span>{props.record.scenarios.length}</span>)
                    </div>
                    <div className="item-values col-names">
                      <div>
                        <p className="col-title">Protocol amendments </p>
                        <p className="col-description">Percent of criteria associated with historical amendments</p>
                      </div>
                      <div>
                      <p className="col-title">Screen failure risk</p>
                        <p className="col-description">Criteria associated with high historical screen failure</p>
                      </div>
                      <div>
                        <p className="col-title">Patient burden</p>
                        <p className="col-description">Expected burden per patient</p>
                      </div>
                      <div>
                        <p className="col-title">Cost</p>
                        <p className="col-description">Expected cost per patient</p>
                      </div>
                      <div>
                        <p className="col-title">Total cost</p>
                        <p className="col-description">Expected cost for all patients</p>
                      </div>
                      <div>
                        <p className="col-title">Protocol complexity</p>
                        <p className="col-description info"><InfoCircleOutlined /> Click the complexity rating for more details</p>
                      </div>
                      <span className="clone_container"></span>

                    </div>
                  </div>
                  {props.record.scenarios.map((s, idx) => {
                    const isTemplate = s?.is_template
                    return (
                      <div
                        className="item-wrapper"
                        style={{cursor:`${props.record.status.toLowerCase() === 'updating'?"not-allowed":"pointer"}`}}
                        key={s["ts_id"] + idx}
                        onClick={() => {
                          if(props.record.status.toLowerCase() === 'updating')return
                          editScenario(s)
                          setIsCreateDrawer(false);
                        }}
                      >
                        <div className="scenario-item">
                          <div className="title">
                            <div className="scenario-item-wrapper">
                              <Text
                                style={{maxWidth: 180, fontSize: '18px'}}
                                className="trial_name"
                                ellipsis={{tooltip:s["scenario_name"]}}
                              >
                                {s["scenario_name"]}
                              </Text>
                              {!!s.finalized && (
                                  <div className="scenario_status-wrapper">
                                  <CheckCircleFilled style={{ fontSize: '17px', color: '#18D300'}} />
                                  <div className="scenario_status">Finalized</div>
                                </div>
                              )}
                            </div>
                            {isTemplate? ( <div className="template-tag">* Template Scenario</div> ):null}
                            <div>
                              <Text
                                style={{width: 290}}
                                className="trial_des"
                                ellipsis={{tooltip:s["scenario_description"]}}
                              >
                                {s["scenario_description"]}
                              </Text>
                            </div>

                            {s.finalized && (
                              <div className="rationale-content">
                                <p>Rationale</p>
                                <Text
                                    style={{width: 150}}
                                    ellipsis={{tooltip:s['rationale']}}
                                  >
                                    {s['rationale']}
                                </Text>
                              </div>
                            )}
                          </div>
                          <div className="item-values">
                            <div>
                              <span>{s["protocol_amendment_rate"]}</span>
                              {/* <span className={`status ${s["protocol_amendment_rate_state"]}`}>{s["protocol_amendment_rate_state"]}</span> */}
                              {/* <span style={{fontSize: 22}}>Future Module</span> */}
                            </div>
                            <div>
                              {s["screen_failure_rate"]!== null?(<span>{s["screen_failure_rate"]}</span>):""}
                               <span className={`status ${s["screen_failure_rate_state"]}`}>{s["screen_failure_rate"]!== null?toSentenceCase(s["screen_failure_rate_state"]):""}</span>
                            </div>
                            <div>
                              {s["dct_patient_burden"]!== null ?  (<span>{roundToWholeNumber(s["dct_patient_burden"])}</span>): ""}
                               <span className={`status ${s["dct_patient_burden_state"]}`}>{toSentenceCase(s["dct_patient_burden_state"])}</span>
                            </div>
                            <div>
                            <span>{formatCostAvg(s["cost"],1000)}</span>
                               <span className={`status ${s["cost_state"]}`}>{toSentenceCase(s["cost_state"])}</span>
                            </div>
                            <div>
                              <span>{formatCostAvg(s["total_enrollment_cost"],1000000,true)}</span>  
                            </div>
                            <div>
                            <span onClick={(e) => openProtocolComplexityDialog(e, s)} className={`complexity ${s["scenario_complexity"]?.split(" ")[0]}`}>{toSentenceCase(s["scenario_complexity"])}</span> 
                            </div>
                            <span className="clone_container">
                              <Popover placement="bottom"  content={getContent(s, idx)} 
                                visible={popoverStates[idx] || false}
                                onVisibleChange={(visible) => handlePopoverVisibleChange(idx, visible)}
                              >
                                <MoreOutlined onClick={(e) => e.stopPropagation()}/>
                              </Popover>
                         </span>

                          </div>

                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )
           : (
            <div className="bottom">Design inclusion / exclusion criteria and schedule of activities</div>
          )}
          {
             props.record.scenarios.length>0 && props.record['therapeutic_area_average'] !==undefined && (
              <div className="item-wrapper average-item">
                <div className="scenario-item">
                  <div className="title average-title" style={{width: 300}}>
                    Similar historical trials 
                  </div>
                  <div className="item-values average">
                    {/* 'Future Module' */}
                    {/* <div>{protocolAmendmentAvg}</div> */}
                    <div></div>
                    <div>{screenFailureAvg}</div>
                    <div>{BurdenAvg}</div>
                    <div>{CostAvgValue}</div>
                    <div></div>
                    <div></div>
                    <span className="clone_container"></span>
                    {/* <div></div> */}
                  </div>
                </div>
              </div>
            )
          }
        </div>
        <ExploreModule
          title="Country / Site selection"
          description="Select countries to support study strategy and execution"
          iconUri={iconSiteSelection}
          disabled={USE_CASS_MODULE?.toString() === 'false' ? true : false}
          handleClickButton={() => addNewSelection() }
        />
        {/* 
          //TODO: need the icon assets for Digital Protocol
        */}
        <ExploreModule
          title="Digital protocol"
          description="Define digital protocol and author key sections"
          iconUri={iconDigitalProtocol}
          //disabled={(readOnlyUser || !props.record['trial_uuid'] ) || disableDigitalProtocolModule|| DIGITIZED_PROTOCOL_MODULE?.toString() === 'false' ? true : false}
          disabled= {true}
          handleClickButton={() => props.history.push('/dprotocol')}  
        />
        <ExploreModule
          title="Trial budgeting"
          description="Select countries to support study strategy and execution"
          iconUri={iconTrialBudgeting}
          disabled= {true}
          handleClickButton={() => { 
            window.location.href = `https://d1h926yowac4q8.cloudfront.net/${props.record['trial_uuid']}`;
          }} 
        />
      </div>
      <Drawer
        title={!cloneScenario ? scenarioType + " - Scenario builder" : `${cloneScenarioDisplayMessages.title} - ${cloneScenarioObj["scenario_name"] }` }
        placement="right"
        closable={true}
        onClose={handleCancel}
        visible={newScenarioVisiable}
        footer={[
          <Button
            className="cancel-btn"
            key="cancel"
            type="text"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button 
          key="submit" 
          type="primary" 
          disabled={disableCreateBtn} 
          onClick={readOnlyUser ? readOnlyUserHandler : handleOk} 
          className="create-update-btn">
            {btnText()}
          </Button>,
        //    <Button key="submit" type="primary" onClick={readOnlyUser ? navigateOldUI : handleOkOldUI} className="create-btn">
        //     SCENARIO OLD 
        //  </Button>,
        ]}
      >
        <Row style={{ minHeight: "300px" }}>
          <Col span={24}>
            <Row>
              <h5>Scenario details</h5>
            </Row>
            <br />
           {cloneScenario && ( <><Row>
              <div style={{backgroundColor:'#F9EAD4', color: '#933401', width: '100%', padding: '2%'}}>{cloneScenarioDisplayMessages.message}</div>
            </Row>
            <br />
            </>
           )}
          {readOnlyUser || (!isAdmin && scenario?.is_template && !cloneScenario) && ( <><Row>
              <div style={{backgroundColor:'#F9EAD4', color: '#933401', width: '100%', padding: '2%'}}>You don't have access to edit this scenario</div>
            </Row>
            <br />
            </>
           )}
            <Row>
              <span>Scenario name </span>
              <span style={{ color: "#d04a02", fontSize: 12, marginTop: 7, lineHeight: '12px'}}>&nbsp;*</span>
            </Row>
            <Row>
              <Input
                onChange={(e) => handleInputChange("scenario_name", e)}
                value={cloneScenario ? cloneScenarioObj["scenario_name"] : scenario["scenario_name"]}
                // maxLength={100}
                onBlur={(v) => handleValidation("scenarioName", v)}
                disabled = {readOnlyUser || (!isAdmin && scenario?.is_template && !cloneScenario)}
              />
              <br/>
                <span className="name-error" style={{ color: "#d04a02"}}>{scenarioNameError}</span>
                {duplicateScenarioError && duplicateScenarioError.length > 0 && ( <span className="name-error" style={{ color: "#d04a02"}}>{duplicateScenarioError}</span>)}

            </Row>
            <br />
            <Row>
              <span>Description</span>
            </Row>
            <Row>
              <TextArea
                value={cloneScenario ? cloneScenarioObj["scenario_description"] : scenario["scenario_description"]}
                onChange={(e) => handleInputChange("scenario_description", e)}
                autoSize={{ minRows: 3, maxRows: 5 }}
                // maxLength={500}
                onBlur={(v) => handleDesValidation("scenarioDescription", v)}
                disabled = {readOnlyUser || (!isAdmin && scenario?.is_template && !cloneScenario)}
              />
              <br/>
              <span className="name-error" style={{ color: "#d04a02"}}>{scenarioDesError}</span>
            </Row>
            {
              record.template_ts_id && isCreateDrawer? (
                <Row className="history-container">
                  <Col span={22}>
                    <div className="switch-container">
                    Would you like to copy content from template scenario?
                    <Switch checked={fromTemplate} onChange={(checked)=>setFromTemplate(checked)} />
                  </div></Col>
                  <Col span={2}>
                 
                  <Popover 
                    content={getScenarioInfo(record)} 
                    title={<>An admin user has designated this scenario as the Template Scenario for the current indication <CloseOutlined style={{paddingTop: '5px', float: 'right', cursor: 'pointer'}}onClick={()=> setVisible(false)}/> </>}
                    trigger="click"
                    visible={visible}
                    onVisibleChange={handleVisibleChange}
                  >
                    <div>
                    <img src={history_icon} alt="" className="history_icon" width="32px" height="32px"/>
                    </div>
                  
                  </Popover>
                  </Col>
                 
                </Row>
              ):null
            }
          </Col>
        </Row>
      </Drawer>

      <Drawer
        className="complete-module-drawer"
        title={"Complete Module:" + scenarioType}
        placement="right"
        onClose={() => setCompleteModuleVisible(false)}
        visible={completeModuleVisible}
        footer={[
          <Button
            key="cancel"
            type="text"
            onClick={cancelCompleteModule}
            style={{ float: "left" }}
          >
            Cancel
          </Button>,
          <Button key="update"
            type="primary"
            className="submit-complete-btn"
            onClick={handleCompleteModule}
            disabled={scenarioList.findIndex(s=>s.finalized)<0}
          >
            Complete module
          </Button>,
        ]}
      >
        <div className="module-tip">
          Note: Once marked as completed, you will not be able to edit this
          trial further.
        </div>
        <div className="select-scenario-wrapper">
          <div className="scenario-table-header">
            <div className="scenario-col scenario-name">Select scenario</div>
            <div className="scenario-col scenario-rate">Protocol amendment risk</div>
            <div className="scenario-col scenario-rate">Screen failure risk</div>
            <div className="scenario-col scenario-rate">Patient burden</div>
            <div className="scenario-col scenario-rate">Cost</div>
          </div>
          <div className="scenario-table-body">
            {scenarioList.map((scenario, idx) => {
              return (
                <div key={`scenario_${idx}`}
                  className={`scenario-table-row-wrapper ${
                    scenario.hasOwnProperty("rationale") ? "checked" : ""
                  }`}
                >
                  <div className="scenario-table-row">
                    <div
                      className={`scenario-col scenario-name ${
                        scenario.hasOwnProperty("rationale") ? "checked" : ""
                      }`}
                    >
                      <div>
                        <Radio
                          checked={scenario.finalized}
                          onChange={(e) => handleCheck(e, idx)}
                        >
                          <Text
                            style={{maxWidth: 120}}
                            className="scenario-name-checkbox"
                            ellipsis={{tooltip:scenario['scenario_name']}}
                          >
                            {scenario["scenario_name"]}
                          </Text>
                        </Radio>
                      </div>
                      <span className="scenario-desc">
                        <Text
                          style={{maxWidth: 120}}
                          className="scenario-des-checkbox"
                          ellipsis={{tooltip:scenario["scenario_description"]}}
                        >
                          {scenario["scenario_description"]}
                        </Text>
                      </span>
                    </div>
                    <div className="scenario-col" style={{fontSize: 24}}>
                      {scenario["protocol_amendment_rate"]}
                      {/* Future Module */}
                       <span className={`status ${scenario["protocol_amendment_rate_state"]}`}>
                         {/* {scenario["protocol_amendment_rate_state"]} */}
                         </span>

                    </div>
                    <div className="scenario-col">
                      {scenario['screen_failure_rate']}
                      <span className={`status ${scenario["screen_failure_rate_state"]}`}> {scenario['screen_failure_rate_state']}</span>
                    </div>
                    <div className="scenario-col">
                      {roundToWholeNumber(scenario['dct_patient_burden'])}
                     <span className={`status ${scenario["dct_patient_burden_state"]}`}> {scenario['dct_patient_burden_state']}</span>
                    </div>
                    <div className="scenario-col">
                      {typeof scenario["cost"] === "number"?`$${scenario["cost"]}`:``}
                       <span className={`status ${scenario["cost_state"]}`}>{scenario['cost_state']}</span>
                    </div>
                  </div>
                  {scenario.finalized ? (
                    <div className="rationale-mark">
                      <span>Provide rationale</span>
                      <div>
                        <TextArea
                          value={scenario.rationale}
                          onChange={(e) => onRationaleChange(e, idx)}
                          autoSize={{ minRows: 3, maxRows: 5 }}
                          // maxLength={500}
                          allowClear
                        />
                      </div>
                      {scenario.rationale && scenario.rationale.length > 500 ? (<span style={{ color: "#d04a02"}}>{rationaleMsgError}</span>) : ''}
                      <span></span>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </Drawer>
      <Modal visible={openDialog} title=""
        mask={false} 
        onCancel={closeDialog} 
        footer={null} 
        style={{ top: 60, height: '80vh' }} 
        centered={false} 
        maskClosable={false}
        destroyOnClose={true}
        className="mvp-modal"
        
        >
      <Row className="configure-title">
      <span>Protocol complexity assessment</span>
      </Row>
    <Row className="table-container">
      <Col span={24} className="event-dashboard" style={{ height: '700px', overflowX: 'scroll', overflowY: 'scroll' }}>
        <div className="collapse-inner">
          <div className="criteria-list">
            <div className="list-columns"></div>
          </div>
          <div className="sectionPanel">
            <Spin spinning={loading}>
         
            <div className="protocol-complexity-container">
                {mvpData.map((section, index) => (
                  <div key={index} className="section">
                    <Collapse
                      className="protocol-header"
                      activeKey={activeKey}
                      onChange={callback}
                      expandIconPosition="right"
                      expandIcon={({ isActive }) => (
                        <DownOutlined rotate={isActive ? 180 : 0} />
                      )}
                    >
                      <Panel
                        key={index}
                        header={
                          <div className="section-header">
                            <h6 style={{ marginTop: '10px', marginLeft: '10px' }}><strong>{section.header}</strong></h6>
                            <span style={{ marginLeft: '4px', marginTop: '8px' }} className={`status ${section.status.toLowerCase()}`}>
                              {section.status}
                            </span>
                          </div>
                        }
                      >
                        <div className="pc-table-container">
                          <div className="pc-table-header">
                            {columns.map((col, idx) => (
                              <div key={idx} className="pc-table-cell pc-header-cell">
                                {col}
                              </div>
                            ))}
                          </div>
                          <div className="pc-table-body">
                            {section.rows.map((row, rowidx) => (
                              <Collapse
                                key={rowidx}
                                className="chart-collapse" 
                                expandIconPosition="right"
                                expandIcon={({ isActive }) => (
                                  <DownOutlined rotate={isActive ? 180 : 0} />
                                )}
                              >
                                <Panel
                                  header={
                                    <div className="pc-table-row">
                                      <div className="pc-table-cell">{row.label}</div>
                                      <div className="pc-table-cell">{row.Trial}</div>
                                      <div className="pc-table-cell">{row.Historic}</div>
                                      <div className={`pc-table-cell ${checkComplexity(row.Percentile)}`}>
                                        {row.Percentile}
                                        <sup className="superscript">{printSuffix(row.Percentile)}</sup>
                                      </div>
                                      <div className="pc-table-cell">
                                      </div>
                                    </div>
                                  }
                                  key={`${index}-${rowidx}`}
                                >
                                  <div className="expanded-row-content">
                                    <div className="pc-chart-container">  
                                      <ReactECharts  option={generateChartOptions(row.label)}/>
                                    </div>  
                                  </div>
                                </Panel>
                              </Collapse>
                            ))}
                          </div>
                        </div>
                      </Panel>
                    </Collapse>
                    <br />
                  </div>
                ))}
            </div>

            </Spin>

          </div>
          </div>
        
      </Col>
    </Row>
      
    </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateSoaActivities: (val) => dispatch(createActions.updateSoaActivities(val)),
});

const mapStateToProps = (state) => ({
  newSoa: state.soaReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SceneriosDashbaord));